import { useCallback, useContext } from 'react';

import { VehicleLookupContext } from 'Context/vehicleLookup';

import { safeLocalStorage } from 'Utilities/storages';

import { VALUATION_LOADER_ENQUIRY_KEY } from './ValuationLoader.const';

export const useValuationLoaderLocalStorage = () => {
  const { vehicleLookupState: vehicle } = useContext(VehicleLookupContext);
  const { id } = vehicle?.enquiry ?? {};

  const setEnquiry = () => {
    safeLocalStorage.setItem(`${VALUATION_LOADER_ENQUIRY_KEY}-${id}`, true);
  };

  const removeEnquiry = () => {
    safeLocalStorage.removeItem(`${VALUATION_LOADER_ENQUIRY_KEY}-${id}`);
  };

  const getEnquiry = useCallback(() => safeLocalStorage.getItem(`${VALUATION_LOADER_ENQUIRY_KEY}-${id}`, false), [id]);

  return { getEnquiry, removeEnquiry, setEnquiry };
};
